<template>
  <div>
    <div v-if="mainContent || subContent" class="cont_wrap">
      <div class="service_info type2">
        <div class="title">{{ mainTitle }}</div>
        <div class="info">
          <p v-html="mainContent" class="ptxt"></p>
        </div>
      </div>
      <div class="service_info type3">
        <div class="title">{{ subTitle }}</div>
        <div class="info">
          <p v-html="subContent" class="ptxt"></p>
        </div>
      </div>
    </div>
    <div v-else class="no_list">
      <div class="box">
        <img src="@/assets/images/img_nolist_record.png" alt="no_record">
        <p>내용이 없습니다.</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'StampInfo',
  data () {
    return {
      mainTitle: '',
      mainContent: '',
      subTitle: '',
      subContent: ''
    }
  },
  computed: {
    ...mapState(['stampDataNew'])
  },
  watch: {
    stampDataNew () {
      if (this.stampDataNew.mingle_poi_no) {
        this.mainTitle = '생태정보'
        this.mainContent = this.poiData().join('<br/>')
        this.subTitle = '개요'
        this.subContent = this.stampDataNew.mingle_poi_desc
      } else {
        this.mainTitle = this.stampDataNew.main_title
        this.mainContent = `${this.stampDataNew.basic_content && this.stampDataNew.basic_content.replaceAll('\n', '<br/>')}<br/><br/>`
        this.mainContent += this.stampDataNew.main_content && this.stampDataNew.main_content.replaceAll('\n', '<br/>')
        this.subTitle = this.stampDataNew.summry_title
        this.subContent = this.stampDataNew.summry_content && this.stampDataNew.summry_content.replaceAll('\n', '<br/>')
      }
    }
  },
  methods: {
    // 생태정보
    poiData () {
      const tArr = ['분 류', '발 견 지', '관찰시기']
      const arr = ['mingle_poi_sub_title', 'mingle_poi_region', 'mingle_poi_season']
      const poiArr = []
      arr.map((val, idx) => {
        const txt = `<strong class='poiTitle'>${tArr[idx]}</strong> ${this.stampDataNew[val]}`
        poiArr.push(txt)
      })
      return poiArr
    }
  }
}
</script>
<style>
  .poiTitle {
    width:50px;
    display: inline-block;
  }
</style>
